import PolicyPage from "./PolicyPage";

export default function TermsPolicy() {
  return <PolicyPage testid="page-terms" policyKey="terms" />;
}
